import { gql } from '@apollo/client';

export const GET_LINE_ITEM_TIRE_NAMES = gql`
  query GET_LINE_ITEM_TIER_NAMES {
    getLineItemTierNamesV5
  }
`;
